import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SecretsOfAnubis_Responsive } from "../SecretsOfAnubis/game_responsive";

export class SecretsOfAnubisLink_Responsive extends SecretsOfAnubis_Responsive {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData ) {
        super(multigameParams, initData, "SecretsOfAnubisLink");
    }
    
}

  


